import ActivitiesService from 'services/activitiesService'
import { IActivityLogResponseAction } from '@urbanx/agx.activities.client';

export const ActivityActionMap = {
  Added: 'Added',
  Created: 'Created',
  Generated: 'Generated',
  Obtained: 'Obtained',
  Updated: 'Updated',
  Completed: 'Completed',
  Converted: 'Converted',
  Uploaded: 'Uploaded',
  SentEmail: 'Sent Email',
  SentViaDocuSign: 'Sent Via DocuSign',
  FailedToSend: 'Failed To Send',
  Archived: 'Archived',
} as const

type ActorDetails = {
  title: string
  firstName: string
  middleName: string
  lastName: string
  preferredName: string
  firstNames: string
  fullName: string
}

type Recipient = {
  emailAddress: string
  recipientName?: string
}

export type ActivityLog = {
  actorId: string
  actorName: ActorDetails
  campaignId: string
  agencyId: string
  recipient: Recipient
  action: IActivityLogResponseAction
  activityMessage: string
  activityDate: string
}

const getCampaignActivityLogs = async (
  getAuthToken: () => Promise<string | void>,
  campaignId: string
): Promise<ActivityLog[] | undefined> => {
  const token = await getAuthToken()
  if (!token || campaignId === '') return

  const service = new ActivitiesService(token)

  if (!service) return

  const result = await service.activitiesService.get('GetCampaignActivityLogs', {
    campaignId
  })

  return result.data || []
}

export default getCampaignActivityLogs
